import { Lightning, Log } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';

import { _constants } from '../../../components/MiniDetail';
import { CmsConstants } from '../../../Business/cms/CmsConstants';
import { ReminderPageDataSource } from '../../../Business/reminder/ReminderPageDataSource';
import { Backend } from '../../../api/Backend';
import { ChannelManager } from '../../../api/ChannelManager';
import { CmsGrid } from '../../../components/cms/CmsGrid';
import { ErrorTranslationKeys } from '../../../api/models/TranslationKeys';

const Constants = {
  header: {
    margin: {
      left: CmsConstants.Ribbon.pageContentOffset,
      top: 74,
    },
    height: 44,
  },
  content: {
    marginLeft: 98,
  },
};

export class ReminderPage extends Lightning.Component {
  static override _template() {
    return {
      x: 0,
      y: 0,
      clipping: true,
      w: (w: number) => w,
      h: (h: number) => h,
      EmptyText: {
        visible: false,
        mount: 0.5,
        x: (w: number) => w / 2,
        y: (h: number) => h / 2,
        text: {
          ...Theme.Fonts.Normal,
          text: '',
        },
      },
      Container: {
        w: (w: number) => w,
        Content: {
          color: Theme.Colors.Transparent,
          flex: { direction: 'column' },
          w: (w: number) => w - Constants.content.marginLeft,
          y: Constants.header.margin.top + Constants.header.height + 10,
        },
      },
    };
  }

  private pageDataSource?: ReminderPageDataSource;
  params?: { backend: Backend; pageType?: string; menuItem?: { pageType: string }; name: string };

  private focusIndex = 0;

  override _init() {
    const backend = this.params?.backend;
    const pageType = this.params?.pageType || this.params?.menuItem?.pageType;
    if (!backend) return Log.error('[ReminderPage]', 'Backend not available');
    this.tag('EmptyText').text.text = backend.translations.forKey(ErrorTranslationKeys.error_no_reminders);
    this.pageDataSource = new ReminderPageDataSource(backend, pageType);
    this.reloadReminderContent();
  }

  private reloadReminderContent() {
    if (!this.params?.backend || !this.pageDataSource)
      return Log.error('[ReminderPage]', 'Backend or pageDS not available');

    ChannelManager.channels(this.params.backend).then(channels => {
      this.pageDataSource!.channels = channels;
      this.pageDataSource!.getReminderContent().then(ds => {
        if (!ds) {
          return;
        }
        const content = this.tag('Content');
        content.childList.clear();
        content.childList.a({
          flexItem: { marginBottom: 20 },
          signals: { centerVertical: '_centerVertical' },
          w: this.finalW,
          contentOffset: CmsConstants.Ribbon.pageContentOffset,
          ...ds.componentDescription(),
        });
        this.focusIndex = content.childList.length > 0 ? 0 : -1;
        this._refocus();
        this.checkShowEmptyMessageBasedOnData();
      });
    });
  }

  override _getFocused() {
    if (this.focusIndex !== -1) {
      return this.tag('Content').children[this.focusIndex];
    }
  }

  _centerVertical(centerY: number) {
    // Workaround for modals
    // Showing/hiding a modal will cause a refocus event, at which point this.finalH === 0
    // Prevent recentering in that case
    if (this.finalH === 0) return;

    let target = this.finalH / 2;

    if (this.tag('Content').children[this.focusIndex].data.cmsProperties) {
      if (!this.tag('Content').children[this.focusIndex].data.cmsProperties.includes('HIDE_MINI_DETAIL')) {
        target = (1080 - _constants.miniDetailHeight) / 2;
      }
    }

    const result = Math.min(
      0, //-this.tag('Content').finalH + this.tag('Content').finalH - constants.marginBottom,
      target - centerY
    );
    // console.log('centerVertical', centerY, target, result, this.tag('Content').finalH);

    this.tag('Container').setSmooth('y', result);
  }

  override _active() {
    this.reloadReminderContent();
    if (this.params?.backend) this.pageDataSource?.logPageView(this.params?.backend, this.params?.name);
  }

  override _handleBack() {
    this.fireAncestors('$focusMenu');
    return true;
  }

  $removeReminderCard(card: Lightning.Component) {
    (this.tag('Content').children[0] as CmsGrid).removeCard(card);
    this.checkShowEmptyMessageBasedOnGrid();
  }

  private checkShowEmptyMessageBasedOnData() {
    const grid = this.tag('Content').children[0] as CmsGrid;
    this.tag('EmptyText').visible = grid.data.items.length <= 0;
  }

  private checkShowEmptyMessageBasedOnGrid() {
    const grid = this.tag('Content').children[0] as CmsGrid;
    this.tag('EmptyText').visible = grid.length <= 0;
  }
}
